import { render, staticRenderFns } from "./OffcanvasCart.vue?vue&type=template&id=640899c1&"
import script from "./OffcanvasCart.vue?vue&type=script&lang=js&"
export * from "./OffcanvasCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports